import * as React from "react";

const CirclePlay = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <g stroke="currentColor" strokeWidth="1.5" clipPath="url(#clip0_1140_4386)">
      <path
        strokeMiterlimit="10"
        d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z"
      ></path>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m16.125 12-6-3.75v7.5z"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_1140_4386">
        <path fill="#fff" d="M0 0h24v24H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default CirclePlay;
